/**
 * Coup de pouce — Attendu 1110 « donner le double, le triple, la moitié, le
 * prédécesseur, le successeur, le carré d'un nombre, en particulier avec la
 * lettre » (automatisme 4e, l. 706). UNE page STATIQUE partagée par les trois
 * generator_keys : un seul exemple modélisant, le double, en nombre puis en
 * lettre ; le geste transférable est la dernière ligne (« avec la lettre,
 * je fais le même calcul »).
 *
 * L'image que l'élève a déjà : les paquets de 1096 et de 1109. Deux paquets
 * de 6, « le double de 6 : 6 × 2 = 12 » ; dessous, deux paquets de n, « le
 * double de n : n × 2 = 2n » ; la ligne du geste : « Avec la lettre, je
 * fais le même calcul : n × 2, c'est 2n. » et le piège nommé : « Pas n + 2 :
 * le double, c'est deux fois. »
 *
 * SACRIFIÉ : (double ; 6) en numérique (gen_1110, SACRIFIE, auto-testé par
 * gen1110.self.test.js) ; « le double de n » reste en carte, résidu assumé.
 * Largeur bornée à 340 px, tailles de 1048.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const BLEU_CLAIR = '#DBEAFE';
const ENCRE = '#1E293B';

/** La lettre, dans la police italique de KaTeX (déclarée par katex.min.css) : le même n que dans les énoncés. */
const N = `<tspan font-family="KaTeX_Math, 'Times New Roman', serif" font-style="italic">n</tspan>`;
const PW = 52;
const PAS = 62;
const P0 = 40;

/** Deux paquets côte à côte, étiquetés `etiquette`, puis le calcul à droite. */
const rangee = (y, etiquette, couleur, fond, calcul) => `
  <rect x="${P0}" y="${y}" width="${PW}" height="40" rx="8" fill="${fond}" stroke="${couleur}" stroke-width="2"/>
  <text x="${P0 + PW / 2}" y="${y + 27}" font-size="17" font-weight="bold" text-anchor="middle" fill="${couleur}">${etiquette}</text>
  <rect x="${P0 + PAS}" y="${y}" width="${PW}" height="40" rx="8" fill="${fond}" stroke="${couleur}" stroke-width="2"/>
  <text x="${P0 + PAS + PW / 2}" y="${y + 27}" font-size="17" font-weight="bold" text-anchor="middle" fill="${couleur}">${etiquette}</text>
  <text x="${P0 + PAS + PW + 18}" y="${y + 27}" font-size="17" font-weight="bold" fill="${ENCRE}">${calcul}</text>`;

const SVG_DOUBLE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 226" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="Le double de 6, puis le double de n. Deux paquets bleus étiquetés 6 : le double de 6, c'est 6 fois 2 égale 12. Dessous, deux paquets orange étiquetés n : le double de n, c'est n fois 2 égale 2 n. Avec la lettre, je fais le même calcul : n fois 2, c'est 2 n. Pas n plus 2 : le double, c'est deux fois.">
  <text x="${P0}" y="28" font-size="12" font-weight="bold" fill="${BLEU}">Le double de 6</text>
  ${rangee(38, 6, BLEU, BLEU_CLAIR, `<tspan fill="${BLEU}">6</tspan> × 2 = <tspan fill="${BLEU}">12</tspan>`)}
  <text x="${P0}" y="108" font-size="12" font-weight="bold" fill="${ORANGE}">Le double de ${N}</text>
  ${rangee(118, N, ORANGE, ORANGE_CLAIR, `<tspan fill="${ORANGE}">${N}</tspan> × 2 = <tspan fill="${ORANGE}">2${N}</tspan>`)}

  <!-- le geste, puis le piège -->
  <text x="200" y="192" font-size="12" text-anchor="middle" fill="${ENCRE}">Avec la lettre, je fais le même calcul : ${N} × 2, c'est <tspan font-weight="bold" fill="${ORANGE}">2${N}</tspan>.</text>
  <text x="200" y="214" font-size="12" text-anchor="middle" fill="${ENCRE}">Pas ${N} + 2 : le double, c'est deux fois.</text>
</svg>`.trim();

const AIDE = { pages: [{ titre: 'Le double de 6, puis avec la lettre', svg: SVG_DOUBLE }] };

const CP_1110 = {
    flash_texte_trou_saisie: AIDE,
    lettre_qcm_unique: AIDE,
    mots_relier: AIDE,
};

export default CP_1110;
